import React from "react";
import Radiomark from "../radiobutton/Radiomark";
import Label from "../label/Label";

const EditCheckboxElement = (props) => {
  let checked = props.arrangemang
    ? props.arrangemang[props.name] === 1 ||
      props.arrangemang[props.name] === 2 ||
      props.arrangemang[props.name] === true
    : props.checked;
  if (!checked || checked === "false") checked = false;

  const labels = props.labels ? props.labels : ["Ja", "Nej"];
  const style = props.inline ? { display: "flex" } : null;
  const containerStyle = props.inlineLabel
    ? { display: "flex", alignItems: "center" }
    : null;
  return (
    <div className="form-group" id={props.id} style={containerStyle}>
      <div style={containerStyle ? { paddingRight: "10px" } : null}>
        <Label {...props} />
      </div>
      <div style={style}>
        <Radiomark
          disabled={props.disabled}
          label={labels[0]}
          name={props.name}
          value="true"
          checked={checked}
          handleEventChange={props.handleEventChange}
        />

        {!labels[1] ? null : (
          <Radiomark
            disabled={props.disabled}
            label={labels[1]}
            name={props.name}
            value="false"
            checked={!checked}
            handleEventChange={props.handleEventChange}
          />
        )}
      </div>
    </div>
  );
};
export default EditCheckboxElement;
